import { useEffect, useState } from "react";
import { fetchPublicStats } from "../lib/api";
import { HomeHero } from "../components/home/HomeHero";
import { ImpactStats } from "../components/home/ImpactStats";
import { MissionSplit } from "../components/home/MissionSplit";
import { Testimonials } from "../components/home/Testimonials";
import { FeaturedBlog, FinalCTA } from "../components/home/FeaturedBlog";

const DEFAULT_STATS = {
    anos_trayectoria: 15,
    vidas_impactadas: 7500,
    voluntarios_activos: 30,
    proyectos_realizados: 22,
    comunidades_atendidas: 19,
};

export default function Home() {
    const [stats, setStats] = useState(DEFAULT_STATS);

    useEffect(() => {
        let cancelled = false;
        fetchPublicStats()
            .then((data) => { if (!cancelled) setStats(data); })
            .catch(() => { /* keep defaults if API fails */ });
        return () => { cancelled = true; };
    }, []);

    return (
        <>
            <HomeHero />
            <ImpactStats stats={stats} />
            <MissionSplit />
            <Testimonials />
            <FeaturedBlog />
            <FinalCTA />
        </>
    );
}
